import ApexCharts from "apexcharts";
import React, { useRef } from "react";

import { ReportTargetType } from "@api/graphql/types-and-hooks";
import { useCaptureCell } from "@components/ChartCapture/hooks/useCaptureCell";
import { CellOutcome } from "@components/ChartCapture/types";
import { TargetProgressGraph } from "@components/TargetPanel/TargetProgressGraph";

export const TargetCaptureCell: React.FC<{
  goalId: string;
  target: ReportTargetType;
  onResult: (outcome: CellOutcome) => void;
  onStart?: () => void;
}> = ({ goalId, target, onResult, onStart }) => {
  const chartRef = useRef<ApexCharts>(null);
  const handleReady = useCaptureCell(chartRef, onResult, onStart);

  return (
    <TargetProgressGraph
      reportGoalId={goalId}
      target={target}
      signedChartImageUrl=""
      chartRef={chartRef}
      onReady={handleReady}
    />
  );
};
